export enum MediaTypeEnum {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio'
}